module.exports = window.CKEDITOR;